'use client';

import { useTranslations } from 'next-intl';
import { useUserData } from '@/contexts/LoginContext';
import { Button } from '@/components/ui/button';
import { useCallback } from 'react';
import { useRouter } from '@/hooks/useRouter';

type ReportListingButtonProps = {
  productOwnerId?: string | null;
  productId: string;
  isArchived?: boolean;
};

export function ReportListingButton({ productOwnerId, productId, isArchived }: ReportListingButtonProps) {
  const t = useTranslations('product');
  const userData = useUserData();
  const router = useRouter();

  const onGoToReport = useCallback(() => {
    router.push(`/support?product_id_for_report=${productId}`);
  }, [productId, router]);

  if (productOwnerId && userData?.id && productOwnerId === userData.id) {
    return null;
  }
  if (isArchived) {
    return null;
  }

  return (
    <div className='lg:mt-[60px] mt-[20px]'>
      <Button
        variant='outline'
        onClick={onGoToReport}
        className='h-auto text-s p-[10px] text-primary bg-transparent hover:bg-transparent border-primary-green-day'
      >
        {t('report')}
      </Button>
    </div>
  );
}
